const referenceReg = `['"](?<reference>[a-z,A-Z0-9\\\\/_-]*)['"]`;
const optionsReg = `(?<options>{[().'"a-z,A-Z0-9#\\:\\s*\\\\/_-]*})`;
const hexReg = `(\\|\\s*(?<hexHash>{\\s*hex\\s*\\:\\s*(?<hex>.+)\\s*}))`;
export const tephraTagReg = /{%\s*tephra\s+.*%}/;
export const tephraReg = new RegExp(`{%\\s*tephra\\s+${referenceReg}(?:\\s*,)?\\s*${optionsReg}?\\s*${hexReg}?\\s*%}`);
